var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigPin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 42,
    viewBox: "0 0 29 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7801 36.3334C26.7801 36.6664 26.6184 37.1066 26.065 37.6356C25.5084 38.1676 24.6367 38.7043 23.4566 39.1815C21.103 40.1331 17.7655 40.7501 14.0151 40.7501C10.2646 40.7501 6.92712 40.1331 4.57347 39.1815C3.39338 38.7043 2.52169 38.1676 1.96512 37.6356C1.41172 37.1066 1.25 36.6664 1.25 36.3334C1.25 36.0004 1.41172 35.5603 1.96512 35.0313C2.52169 34.4992 3.39338 33.9625 4.57347 33.4853C6.92712 32.5337 10.2646 31.9167 14.0151 31.9167C17.7655 31.9167 21.103 32.5337 23.4566 33.4853C24.6367 33.9625 25.5084 34.4992 26.065 35.0313C26.6184 35.5603 26.7801 36.0004 26.7801 36.3334Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8118 2C7.96486 2 2.66943 6.73461 2.66943 12.5767C2.66943 18.4174 7.50106 25.3906 13.8118 35.3913C20.1226 25.3906 24.9542 18.4174 24.9542 12.5767C24.9542 6.73461 19.6602 2 13.8118 2ZM13.8118 17.3043C11.504 17.3043 9.63344 15.4358 9.63344 13.1304C9.63344 10.825 11.504 8.95652 13.8118 8.95652C16.1197 8.95652 17.9902 10.825 17.9902 13.1304C17.9902 15.4358 16.1197 17.3043 13.8118 17.3043Z",
    fill: "#B7E4F5",
    stroke: "black",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPin);
export default __webpack_public_path__ + "static/media/big_pin.f0358fcfc04de814aa6a9cc5f7ed3fa1.svg";
export { ForwardRef as ReactComponent };